import { useState, useEffect } from 'react';
import NiceModal from '@ebay/nice-modal-react';
import ConfirmModal from '/src/components/modal/ConfirmModal/ConfirmModal';
import { useBotStateContext } from '../../../contexts/BotContext';
import { readHistory, writeHistory, createHistoryEntry, HISTORY_MAX_ENTRIES } from '../aiHistoryStorage';

const useTeiaHistory = () => {
    const { botName } = useBotStateContext();
    const [history, setHistory] = useState(readHistory);
    useEffect(() => { writeHistory(history); }, [history]);

    const [selectedEntryId, setSelectedEntryId] = useState(null);

    const botHistory = history.filter((entry) => entry.botName === botName);
    const selectedEntry = botHistory.find((entry) => entry.id === selectedEntryId) || botHistory[0] || null;

    const addHistoryEntry = (fields) => {
        const entry = createHistoryEntry({ botName, ...fields });
        setHistory((previous) => [entry, ...previous].slice(0, HISTORY_MAX_ENTRIES));
        setSelectedEntryId(null);
        return entry;
    };

    const patchHistoryEntry = (id, patch) => setHistory((previous) => previous.map((entry) => entry.id === id ? { ...entry, ...patch } : entry));

    const deleteHistoryEntry = (entry) => {
        setHistory((previous) => previous.filter((item) => item.id !== entry.id));
        if (selectedEntryId === entry.id) setSelectedEntryId(null);
    };

    const clearBotHistory = async () => {
        const confirmed = await NiceModal.show(ConfirmModal, {
            title: 'Clear history',
            body: 'Clear the whole history of this bot? The blocks on the canvas are not touched.',
            confirmLabel: 'Clear',
            danger: true,
        });
        if (!confirmed) return;
        setHistory((previous) => previous.filter((entry) => entry.botName !== botName));
        setSelectedEntryId(null);
    };

    return { history, botHistory, selectedEntryId, setSelectedEntryId, selectedEntry, addHistoryEntry, patchHistoryEntry, deleteHistoryEntry, clearBotHistory };
};

export default useTeiaHistory;
